import React from "react";
import "../../../../components/themes/feedmeonline.css";

const Header3 = (props) => {
  const { ctaUrl, blockKey, brandGuidelines } = props;
  const { primaryLogo, primaryColours } = brandGuidelines;

  return (
    <table
      key={blockKey}
      width="100%"
      border="0"
      cellpadding="0"
      cellspacing="0"
      role="presentation"
    >
      <tbody>
        <tr>
          <td
            class="header3Wrapper"
            bgcolor={primaryColours[0]}
            valign="top"
            style={{ backgroundColor: primaryColours[0] }}
          >
            <table
              width="100%"
              border="0"
              cellpadding="0"
              cellspacing="0"
              role="presentation"
            >
              <tbody>
                <tr>
                  <td align="left" valign="top">
                    <a
                      href={ctaUrl}
                      className="header3IconLink"
                      onClick={(e) => e.preventDefault()}
                    >
                      <img
                        src={`${primaryLogo}?x-timestamp=${Date.now()}`}
                        width="134"
                        alt=""
                        className="header3LogoImage"
                        crossOrigin="anonymous"
                      />
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default Header3;
